import { newPagePermissions } from '../services/permissions/newPermissions';

export default class Permission {

    rolePermission = (type: string[], roles: any): boolean => {
        return newPagePermissions(type, roles);
    }

   
    validate(authorized: boolean, path: string, token: any, roles: any, user: any) {
        if (path !== "/") {
            var pathRoute = path.split('/');
            path = "/" + pathRoute[1];
        }
        switch (path) {
            case '/login':
                if (!authorized) {
                    return true;
                }
                return false
            case '/':
                if (authorized) {
                    return true;
                }
                return false
            case '/distributors':
                if (authorized && this.rolePermission(['DISTRIBUTOR', 'ADMIN'], token, roles)) {
                    return true
                }
                return false
            case '/history':
                if (authorized && this.rolePermission(['DISTRIBUTOR'], token, roles)) {
                    return true;
                }
                return false
            case '/adminHistory':
                if (authorized && this.rolePermission(['ADMIN'], token, roles)) {
                    return true;
                }
                return false
            case '/agents':
                if (authorized && this.rolePermission(['DISTRIBUTOR'], token, roles)) {
                    return true;
                }
                return false
            case '/adminAgents':
                if (authorized && this.rolePermission(['ADMIN'], token, roles)) {
                    return true;
                }
                return false
            case '/products':
                if (authorized && this.rolePermission(['ADMIN', 'DISTRIBUTOR'], token, roles)) {
                    return true;
                }
                return false
            case '/alerts':
                if (authorized && this.rolePermission(['ADMIN', 'DISTRIBUTOR'], token, roles)) {
                    return true;
                }
                return false
            case '/links':
                if (authorized && this.rolePermission(['ADMIN', 'DISTRIBUTOR'], token, roles)) {
                    return true;
                }
                return false
            case '/users':
                if (authorized && this.rolePermission(['ADMIN'], token, roles)) {
                    return true;
                }
                return false
            case '/auditors':
                if (authorized && this.rolePermission(['ADMIN', 'AUDITOR'], token, roles)) {
                    return true;
                }
                return false
            case '/auditeds':
                if (authorized && this.rolePermission(['ADMIN'], token, roles)) {
                    return true;
                }
                return false
            case '/audits':
                if (authorized && this.rolePermission(['ADMIN'], token, roles)) {
                    return true;
                }
                return false
            case '/assignment':
                if (authorized && this.rolePermission(['ADMIN'], token, roles)) {
                    return true;
                }
                return false
            case '/goals':
                if (authorized && this.rolePermission(['ADMIN'], token, roles)) {
                    return true;
                }
                return false

            case '/dashboard':
                if (authorized && this.rolePermission(['ADMIN'], token, roles)) {
                    return true;
                }
                return false
            case '/historyweb':
                if (authorized && this.rolePermission(['ADMIN'], token, roles)) {
                    return true;
                }
                return false
            case '/qahistory':
                if (authorized && this.rolePermission(['ADMIN'], token, roles) ) {
                    return true;
                }
                return false
            case '/profile':
                if (authorized && this.rolePermission(['ADMIN'], token, roles)) {
                    return true;
                }
                return false
            case '/client':
                if (authorized && this.rolePermission(['ADMIN'], token, roles)) {
                    return true;
                } 
                return false   
            case '/permissions':
                if (authorized && this.rolePermission(['ADMIN'], token, roles)) {
                    return true;
                }
                return false
            case '/formflowProcess':
                if (authorized && this.rolePermission(['ADMIN'], token, roles)) {
                    return true;
                }
                return false
            case '/componentFormflow':
                if (authorized && this.rolePermission(['ADMIN'], token, roles)) {
                    return true;
                }
                return false
            case '/productionlines':
                if (authorized && this.rolePermission(['ADMIN'], token, roles)) {
                    return true;
                }
                return false
            case '/model3d':
                if (authorized && this.rolePermission(['ADMIN'], token, roles)) {
                    return true;
                }
                return false
            case '/workstations':
                if (authorized && this.rolePermission(['ADMIN'], token, roles)) {
                    return true;
                }
                return false
            case '/workflows':
                if (authorized && this.rolePermission(['ADMIN'], token, roles)) {
                    return true;
                }
                return false
            case '/workflow':
                if (authorized && this.rolePermission(['ADMIN'], token, roles)) {
                    return true;
                }
                return false
            case '/notifications':
                if (authorized && this.rolePermission(['ADMIN'], token, roles)) {
                    return true;
                }
                return false
            case '/formflowProcess':
                if (authorized && this.rolePermission(['ADMIN'], token, roles)) {
                    return true;
                }
                return false
            case '/ticketdetailsqafs':
                if (authorized && this.rolePermission(['ADMIN'], token, roles)) {
                    return true;
                }
                return false
            case '/ticketdetailsehss':
                if (authorized && this.rolePermission(['ADMIN'], token, roles)) {
                    return true;
                }
                return false
            case '/manager':
                if (authorized && this.rolePermission(['ADMIN'], token, roles)) {
                    return true;
                }
                return false
            case '/ticket':
                //TECHNICAL DEBT: we weren't being able to click on the notifications on EHSS
                //because the roles being received were auditor and assignment, so I just added them
                //to the allowed roles
              if (authorized && this.rolePermission(['ADMIN', 'AUDITOR', 'ASSIGNMENT'], token, roles)) {
                    return true;
                }
                return false
            case '/export':
                if (authorized && this.rolePermission(['ADMIN'], token, roles)) {
                    return true;
                }
                return false
            case '/targets':
                if (authorized && this.rolePermission(['ADMIN'], token, roles)) {
                    return true;
                }
                return false
            case '/processmanagement':
                if (authorized && this.rolePermission(['ADMIN', 'ASSIGNMENT'], token, roles)) {
                    return true;
                }
                return false
            case '/liteProcesses':
                if (authorized && this.rolePermission(['ADMIN'], token, roles)) {
                    return true;
                }
                return false;
            case '/process':    
                if (authorized && this.rolePermission(['ADMIN', 'ASSIGNMENT'], token, roles)) {
                    return true;
                }
                return false;
            case '/liteReports':
                if (authorized && this.rolePermission(['ADMIN', 'ASSIGNMENT'], token, roles)) {
                    return true;
                }
                return false;
            case '/scheduler':
                if(authorized && this.rolePermission(['ADMIN', 'ASSIGNMENT', 'AUDITOR', 'DISTRIBUTOR'], token, roles)) {
                    return true
                }
                return false;
            case '/my-processes':
                if(authorized && this.rolePermission(['ADMIN', 'ASSIGNMENT', 'AUDITOR', 'DISTRIBUTOR'], token, roles)) {
                    return true
                }
                return false;
            default:
                return false;
        }
    }
}